/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
.display1 {
  font-size: 48px;
  font-weight: normal;
  line-height: 125%;
}
.display1.bold,
.display1 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display1 {
    font-size: 30px;
    line-height: 150%;
  }
}

.display2 {
  font-size: 40px;
  font-weight: normal;
  line-height: 125%;
}
.display2.bold,
.display2 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display2 {
    font-size: 27px;
    line-height: 150%;
  }
}

.display3 {
  font-size: 36px;
  font-weight: normal;
  line-height: 125%;
}
.display3.bold,
.display3 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display3 {
    font-size: 24px;
    line-height: 150%;
  }
}

.heading1 {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.heading1.bold,
.heading1 .bold {
  font-weight: 600;
}

.heading2 {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.heading2.bold,
.heading2 .bold {
  font-weight: 600;
}

.heading3 {
  font-size: 18px;
  font-weight: normal;
  line-height: 150%;
}
.heading3.bold,
.heading3 .bold {
  font-weight: 600;
}

.heading4 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.heading4.bold,
.heading4 .bold {
  font-weight: 600;
}

.subheading1 {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading2 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading3 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.body1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.body1.bold,
.body1 .bold {
  font-weight: 600;
}

.body2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.body2.bold,
.body2 .bold {
  font-weight: 600;
}

.body3 {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.body3.bold,
.body3 .bold {
  font-weight: 600;
}

.button1 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.button2 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.link1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link1.bold,
.link1 .bold {
  font-weight: 600;
}

.link2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link2.bold,
.link2 .bold {
  font-weight: 600;
}

.link3 {
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link3.bold,
.link3 .bold {
  font-weight: 600;
}

.small-label1 {
  font-size: 12px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.small-label2 {
  font-size: 10px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.cursor-pointer {
  cursor: pointer;
}

.underline {
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.no-text-transform {
  text-transform: none;
}

.gray {
  color: #a6a6a6;
}

.light-gray {
  color: #ccc;
}

.lighter-gray {
  color: #eaeaea;
}

.lightest-gray {
  color: #f5f5f5;
}

.dark-gray {
  color: #767676;
}

.darker-gray {
  color: #606060;
}

.darkest-gray {
  color: #404040;
}

.purple {
  color: #5b1dc2;
}

.dark-purple {
  color: #4b18a1;
}

.white {
  color: #fff;
}

.black {
  color: #000;
}

.red {
  color: #fd868c;
}

.darker-red {
  color: #d43838;
}

.dark-orange {
  color: #ff8313;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.normal {
  font-weight: normal;
}

.PlanOption {
  position: relative;
}

.discountBanner {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.discountBanner.bold,
.discountBanner .bold {
  font-weight: 600;
}
.discountBanner {
  font-weight: 600;
  background: linear-gradient(90deg, #fdf0c6 0%, #ed5e5e 275%);
  border-radius: 22px;
  height: 22px;
  padding: 2px 8px;
  position: absolute;
  top: -11px;
}

:global(.InteractiveElement).card {
  border: 1px solid #eaeaea;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: 211px;
  overflow: hidden;
  width: 278px;
}
:global(.InteractiveElement).card:not(.showInput) {
  cursor: default;
}
:global(.InteractiveElement).card.checked {
  border: 1px solid #7bb7cf;
}
:global(.InteractiveElement).card.showInput:not(.checked):hover, :global(.InteractiveElement).card.showInput:not(.checked):focus {
  border: 1px solid #5b1dc2;
}
:global(.InteractiveElement).card.showInput:not(.checked):hover .radioInput, :global(.InteractiveElement).card.showInput:not(.checked):focus .radioInput {
  background: #d6c7f0;
}

.topSection {
  align-items: flex-start;
  background: #f0f7fa;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
  width: 100%;
}

.topRow {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
}

.radioInput {
  background: #fff;
  border: 3px solid #fff;
  border-radius: 36px;
  box-shadow: 0 0 0 1px #ccc;
  flex-shrink: 0;
  height: 20px;
  width: 20px;
}
.radioInput.checked {
  background: #5b1dc2;
  box-shadow: 0 0 0 1px #e9e1f8;
}

.titleSection {
  font-size: 18px;
  font-weight: normal;
  line-height: 150%;
}
.titleSection.bold,
.titleSection .bold {
  font-weight: 600;
}
.titleSection {
  font-weight: 600;
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.title {
  margin-bottom: unset;
}

.price {
  justify-content: flex-end;
}

.discountedFullPrice {
  color: #606060;
  text-decoration: line-through;
}

.newPrice {
  text-decoration: unset;
}

.subtitle {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.subtitle.bold,
.subtitle .bold {
  font-weight: 600;
}
.subtitle.showInput {
  margin-left: 29px;
}

.benefitListSection {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.benefitListSection.bold,
.benefitListSection .bold {
  font-weight: 600;
}
.benefitListSection {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
}

.bullets {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BenefitListItem {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.listIcon {
  height: 20px;
  width: 20px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */